import React from 'react'
import { useNavigate } from 'react-router-dom'
import Table from '../../../../components/common/Table/Table'
import {
  setSelectedEmployee,
  type ManualTimeOffEmployee,
} from '../../../../store/slices/admin/manualTimeOffSlice'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { profileData } from '../../../../store/slices/profileSlice'

interface Props {
  results: ManualTimeOffEmployee[]
}

const EmployeeResultsTable: React.FC<Props> = ({ results }) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const profile = useAppSelector(profileData)

  if (!results) return null

  const columns = [
    { key: 'names', label: 'Name' },
    { key: 'nuid', label: 'NUID' },
    { key: 'authorizedApprover', label: 'Authorized Approver' },
    { key: 'region', label: 'Region' },
    { key: 'department', label: 'Department' },
  ]

  const rows = results.map((emp) => ({
    names: (
          <button
          type='button'
          onClick={async () => {
          const selectedEmployee = {
            nuid: emp.nuid,
            name: emp.name,
            admin: {
              adminNuid: profile?.employee.empNuid,
              adminName: `${profile?.employee.empFirstName} ${profile?.employee.empLastName}`,
            },
          }
          // Store in Redux and sessionStorage — this is request-scoped "acting
          // on behalf of" context only. The authenticated proxy's own session
          // identity (profile, roles) must never be refetched or replaced here;
          // the Requestor page gets the selected employee's details via
          // employeeInfoSlice, which is independently scoped by the same
          // X-emp-nuid header without touching the logged-in user's profile.
          dispatch(setSelectedEmployee(selectedEmployee))

          navigate('/admin/requestor')
        }}
        className="p3 -medium text-[#0074AD]! underline! bg-transparent border-0 cursor-pointer hover:opacity-80"
      >
        {emp.name}
      </button>
    ),
    nuid: emp.nuid,
    authorizedApprover: emp.authorizedApprover || 'None Assigned.',
    department: emp.department,
    region: emp.region || '-',
  }))
  return (
    <div>
      <p className="p3 -medium mb-2 mt-4!">{results.length} results found.</p>
      <Table columns={columns} rows={rows} showPagination={false} />
    </div>
  )
}

export default EmployeeResultsTable
